import { render } from "./ContactsMini.vue?vue&type=template&id=311e4894"
import script from "./ContactsMini.vue?vue&type=script&lang=js"
export * from "./ContactsMini.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__